module.exports = {
      id: "ba839b9770ab2f4e11b1a5053890ad97toiletEquipment-bidet.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#ba839b9770ab2f4e11b1a5053890ad97toiletEquipment-bidet.svg",
      toString: function () {
        return this.url;
      }
    }